import { render, staticRenderFns } from "./UsersCreateEdit.vue?vue&type=template&id=c963be76&scoped=true&"
import script from "./UsersCreateEdit.vue?vue&type=script&lang=js&"
export * from "./UsersCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./UsersCreateEdit.vue?vue&type=style&index=0&id=c963be76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c963be76",
  null
  
)

export default component.exports